"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logger = exports.STATUSES = exports.HandlerType = exports.StatusType = void 0;
var browser_core_1 = require("@datadog/browser-core");
exports.StatusType = {
    debug: 'debug',
    error: 'error',
    info: 'info',
    warn: 'warn',
};
exports.HandlerType = {
    console: 'console',
    http: 'http',
    silent: 'silent',
};
exports.STATUSES = Object.keys(exports.StatusType);
var Logger = /** @class */ (function () {
    function Logger(sender) {
        this.sender = sender;
    }
    Logger.prototype.log = function (message, messageContext, status) {
        if (status === void 0) { status = exports.StatusType.info; }
        this.sender.sendLog(message, (0, browser_core_1.combine)({
            origin: browser_core_1.ErrorSource.LOGGER,
        }, messageContext), status);
    };
    Logger.prototype.debug = function (message, messageContext) {
        this.log(message, messageContext, exports.StatusType.debug);
    };
    Logger.prototype.info = function (message, messageContext) {
        this.log(message, messageContext, exports.StatusType.info);
    };
    Logger.prototype.warn = function (message, messageContext) {
        this.log(message, messageContext, exports.StatusType.warn);
    };
    Logger.prototype.error = function (message, messageContext) {
        var errorOrigin = {
            error: {
                // Todo: remove error origin in the next major version
                origin: browser_core_1.ErrorSource.LOGGER,
            },
        };
        this.log(message, (0, browser_core_1.combine)(errorOrigin, messageContext), exports.StatusType.error);
    };
    Logger.prototype.setContext = function (context) {
        this.sender.getContextManager().set(context);
    };
    Logger.prototype.addContext = function (key, value) {
        this.sender.getContextManager().add(key, value);
    };
    Logger.prototype.removeContext = function (key) {
        this.sender.getContextManager().remove(key);
    };
    Logger.prototype.setHandler = function (handler) {
        this.sender.setHandler(handler);
    };
    Logger.prototype.setLevel = function (level) {
        this.sender.setLevel(level);
    };
    __decorate([
        browser_core_1.monitored
    ], Logger.prototype, "log", null);
    return Logger;
}());
exports.Logger = Logger;
//# sourceMappingURL=logger.js.map